import { computed } from 'vue'
import { Capacitor } from '@capacitor/core'

/**
 * Reactive composable for Capacitor platform detection.
 * Safe to call in all environments (web, iOS, Android).
 */
export function usePlatform() {
  const isNative = computed<boolean>(() => Capacitor.isNativePlatform())
  const platform = computed<'ios' | 'android' | 'web'>(() => Capacitor.getPlatform() as 'ios' | 'android' | 'web')
  const isIos = computed(() => platform.value === 'ios')
  const isAndroid = computed(() => platform.value === 'android')

  return { isNative, platform, isIos, isAndroid }
}
